import Vue from 'vue'
import axios from 'axios'
import {MessageBox, Message, Loading} from 'element-ui'
import store from '@/store'
import router, {resetRouter} from "@/router";
import { saveAs } from 'file-saver'

import  { tansParams ,blobValidate} from '@/utils/index'
/**
 * loading框设置局部刷新，且所有请求完成后关闭loading框
 */
let downloadLoadingInstance;

let loading
let needLoadingRequestCount = 0 // 声明一个对象用于存储请求个数
function startLoading() {
  loading = Vue.prototype.$loading({
    lock: true,
    text: '加载中,请稍后',
    background: 'rgba(0,0,0,0.5)',
  })
}

function endLoading() {
  loading.close()
}

function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

function hideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // 跨域请求时发送cookies
  timeout: 60 * 1000 * 5 // 请求超时
})

// 请求超时请求拦截器
service.interceptors.request.use(
  config => {
    // 在发出请求前做点什么
    if (store.getters.token) {
      // 让每个请求携带令牌
      // ['X-Token'] 是自定义头密钥
      // 请根据实际情况修改
      config.headers['token'] = sessionStorage.getItem('token')
    }
    if (config.loading) { // 如果配置了isLoading则显示，否则不显示loading
      showFullScreenLoading()
    }
    return config
  },
  error => {
    // 处理请求错误
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
var confirmFlag = true;//防止登录失效弹出框重复弹出
// 响应拦截器
service.interceptors.response.use(
  /**
   * 如果您想要获取诸如头或状态之类的http信息
   * 请返回response=>response
   */

  /**
   * 通过自定义代码确定请求状态
   * 这里只是一个例子
   * 您还可以通过HTTP状态代码判断状态
   */
  response => {
    hideFullScreenLoading() // 响应成功关闭loading
    const res = response.data;


       // 二进制数据则直接返回
       if (response.request.responseType ===  'blob' || response.request.responseType ===  'arraybuffer') {
        let fileName = decodeURI(response.headers['content-disposition'].split('attachment;filename=')[1]  || "") || ""
        return {data:response.data,fileName}
      }

    //请求状态码：0成功 1失败 -1 登录过期
    if (res.code == '0') {
      return res
    } else if (res.code == '1') {
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 3000
      });
    } else if (res.code == '-1') {
      if (confirmFlag) {
        confirmFlag = false;
        // 重新登录
        if (!sessionStorage.getItem('token')) {
          return false
        }
        MessageBox.confirm('登录过期，请重新登录', '登录过期', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          showClose: false,
          showCancelButton: false,
          closeOnPressEscape: false,
          center: true,
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          sessionStorage.clear();
          resetRouter()
          router.push({path: '/login'})
          // confirmFlag = true;
          return Promise.reject(new Error(res.msg || 'Error'))
        })
      }
    } else {
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 3000
      });
      return Promise.reject(new Error(res.msg || 'Error'))
    }
  },
  error => {
    hideFullScreenLoading() // 响应成功关闭loading
    console.log('err' + error.message) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)


// 通用下载方法
export function download(url, params, filename, config) {
  downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
  return service.post(url, params, {
    // transformRequest: [(params) => { return tansParams(params) }],
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'blob',
    ...config
  }).then(async (data) => {
     filename = data.fileName || filename
     data = data.data
    const isBlob = blobValidate(data);
    if (isBlob) {
      const blob = new Blob([data])
      saveAs(blob, filename)
    } else {
      const resText = await data.text();
      const rspObj = JSON.parse(resText);
      const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
      Message.error(errMsg);
    }
    downloadLoadingInstance.close();
  }).catch((r) => {
    console.error(r)
    Message.error('下载文件出现错误，请联系管理员！')
    downloadLoadingInstance.close();
  })
}



// 通用下载方法
export function downloadGet(url, params, filename, config) {
  downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
  return service.get(url, {
    responseType: 'blob',
    params,
    ...config
  }).then(async (data) => {
     filename = data.fileName || filename
     data = data.data
    const isBlob = blobValidate(data);
    if (isBlob) {
      const blob = new Blob([data])
      saveAs(blob, filename)
    } else {
      const resText = await data.text();
      const rspObj = JSON.parse(resText);
      const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
      Message.error(errMsg);
    }
    downloadLoadingInstance.close();
  }).catch((r) => {
    console.error(r)
    Message.error('下载文件出现错误，请联系管理员！')
    downloadLoadingInstance.close();
  })
}

export default service
